import {
    FETCH_PLAYERWISE_SALE_FAILURE,
    FETCH_PLAYERWISE_SALE_REQUEST,
    FETCH_PLAYERWISE_SALE_SUCCESS,
  } from '../actions/playerWiseReportingActions';
  
  const initialState = {
    data: [],
    loading: false,
    error: null,
  };
  
  export const playerWiseSaleReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PLAYERWISE_SALE_REQUEST:
        return { ...state, loading: true, error: null };
      case FETCH_PLAYERWISE_SALE_SUCCESS:
        console.log('action>>', action);
        return { ...state, loading: false, data: action.payload };
      case FETCH_PLAYERWISE_SALE_FAILURE:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  